// src/lib/dashboard/janelaParaPeriodoComercial.ts
import type { JanelaPeriodo } from './periodoDashboard.ts';
import type { Periodo, CustomRange } from '../periodoFiltro.ts';
import { janelaParaDatasDia } from './janelaParaDatasDia.ts';

// Ponte entre a janela de mês do filtro do dashboard e o par Periodo/CustomRange
// que eventFunnel.ts (Analytics Comercial) já espera — evita duplicar a lógica
// de filtro por data que já existe em src/lib/periodoFiltro.ts::inPeriodo.
// Reaproveita janelaParaDatasDia (Plano 3, Marketing) pro cálculo de início/fim.
export function janelaParaPeriodoComercial(janela: JanelaPeriodo | null, hoje: Date): { periodo: Periodo; customRange: CustomRange } {
  if (!janela) return { periodo: 'tudo', customRange: { inicio: '', fim: '' } };
  const { inicio, fim } = janelaParaDatasDia(janela, hoje);
  return { periodo: 'personalizado', customRange: { inicio, fim } };
}
